module.exports = __webpack_public_path__ + "img/error.1f4c0401.svg";